import { createContext, useContext } from 'react'
import { TCreditType } from '../types'

export type CreditsContextValue = {
 type?: TCreditType
}

export const CreditsContext = createContext<CreditsContextValue>({})

export const useCreditContext = () => useContext(CreditsContext)
